<ion-header class="extendido">
  <ion-buttons>
    <ion-button (click)="closeModal()">
      <i class="fa-regular fa-chevron-left chevron-back-button"></i>
    </ion-button>

    <ion-title>{{ 'Check in e Check out' | translate}}</ion-title>

    <ion-col class="end-filter" *ngIf="filtro.t == 'inscritos'">
      <div (click)="leitor();">
        <i class="fas fa-qrcode qr" aria-hidden="true"></i>
      </div>
    </ion-col>
  </ion-buttons>
</ion-header>

<ion-content>
  <div class="gradient-extendido">
    <div>
      <ion-searchbar show-cancel-button="never" class="custom" *ngIf="filtro.t == 'inscritos'"
        (ionCancel)="onCancel()" placeholder="{{'Buscar Inscrito' | translate}}" [(ngModel)]="filtro.q"
        (ionInput)="onInput()">
      </ion-searchbar>
    </div>
  </div>

  <div>
    <ion-grid>
      <ion-row>
        <ion-col size="auto">
          <ion-list lines="none">
            <ion-item>
              <ion-select interface="popover" [(ngModel)]="filtro.t" class="select-outline">
                <ion-select-option value="inscritos">{{'Inscritos ' | translate}}</ion-select-option>
                <ion-select-option value="responsavel">{{'Responsável' | translate}}</ion-select-option>
              </ion-select>
            </ion-item>
          </ion-list>
        </ion-col>
      </ion-row>
    </ion-grid>

    <ion-grid *ngIf="filtro.t == 'inscritos'" class="label-icons">
      <ion-row *ngFor="let inscrito of inscritosList;" (click)="selecionar(inscrito);">
        <ion-col size="2">
          <ion-avatar>
            <img [src]="inscrito.foto | image:' '" />
          </ion-avatar>
        </ion-col>

        <ion-col size="8">
          <ion-label>
            <h5>{{inscrito.nome}}</h5>

            <p *ngIf="inscrito.entidade == 'grupoxpessoa' ">
              <i *ngIf="!inscrito.checkin" class="fas fa-times"></i>
              <i *ngIf="inscrito.checkin && !inscrito.checkout" class="fas fa-check"></i>
              <i *ngIf="inscrito.checkin && inscrito.checkout" class="fas fa-check-double"></i>
              {{'Participante' | translate}}
            </p>

            <p *ngIf="inscrito.entidade == 'grupoxvisitante' ">
              <i *ngIf="!inscrito.checkin" class="fas fa-times"></i>
              <i *ngIf="inscrito.checkin && !inscrito.checkout" class="fas fa-check"></i>
              <i *ngIf="inscrito.checkin && inscrito.checkout" class="fas fa-check-double"></i>
              {{'Visitante' | translate}}
            </p>

            <p *ngIf="inscrito.entidade == 'projetoxvisitanteesporadico' ">
              <i *ngIf="!inscrito.checkin" class="fas fa-times"></i>
              <i *ngIf="inscrito.checkin && !inscrito.checkout" class="fas fa-check"></i>
              <i *ngIf="inscrito.checkin && inscrito.checkout" class="fas fa-check-double"></i>
              {{'Esporádico' | translate}}
            </p>
          </ion-label>
        </ion-col>

        <ion-col size="2" class="icon-arrow">
          <i class="fa-regular fa-chevron-right icon-list"></i>
        </ion-col>
        <ion-item-divider></ion-item-divider>
      </ion-row>

      <ion-infinite-scroll (ionInfinite)="loadInscritos($event)" *ngIf="pagination.currentPage < pagination.pageCount">
        <ion-infinite-scroll-content loadingText="{{'Carregando' | translate}}..."></ion-infinite-scroll-content>
      </ion-infinite-scroll>

      <ion-list *ngIf="!inscritosList.length">
        <sem-registro></sem-registro>
      </ion-list>
    </ion-grid>

    <ion-grid *ngIf="filtro.t == 'responsavel'" class="label-icons">
      <ion-row *ngFor="let i of dependetesResponsavel;" (click)="selecionar(i);">
        <ion-col size="2">
          <ion-avatar>
            <img [src]="i.foto | image:' '" />
          </ion-avatar>
        </ion-col>

        <ion-col size="8">
          <ion-label>
            <h5>{{i.nome}}</h5>

            <p *ngIf="i.entidade == 'grupoxpessoa' ">
              <i *ngIf="!i.checkin" class="fas fa-times"></i>
              <i *ngIf="i.checkin && !i.checkout" class="fas fa-check"></i>
              <i *ngIf="i.checkin && i.checkout" class="fas fa-check-double"></i>
              {{'Participante' | translate}}
            </p>

            <p *ngIf="i.entidade == 'grupoxvisitante' ">
              <i *ngIf="!i.checkin" class="fas fa-times"></i>
              <i *ngIf="i.checkin && !i.checkout" class="fas fa-check"></i>
              <i *ngIf="i.checkin && i.checkout" class="fas fa-check-double"></i>
              {{'Visitante' | translate}}
            </p>

            <p *ngIf="i.entidade == 'projetoxvisitanteesporadico' ">
              <i *ngIf="!i.checkin" class="fas fa-times"></i>
              <i *ngIf="i.checkin && !i.checkout" class="fas fa-check"></i>
              <i *ngIf="i.checkin && i.checkout" class="fas fa-check-double"></i>
              {{'Esporádico' | translate}}
            </p>
          </ion-label>
        </ion-col>

        <ion-col size="2" class="icon-arrow">
          <i class="fa-regular fa-chevron-right icon-list"></i>
        </ion-col>
        <ion-item-divider></ion-item-divider>
      </ion-row>

      <ion-list *ngIf="!dependetesResponsavel.length && responsavelFiltrado">
        <sem-registro [text]="'Nenhum Responsável Localizado'"></sem-registro>
      </ion-list>

      <div *ngIf="!responsavelFiltrado">
        <p class="qrcode-icon">
          <i class="fas fa-qrcode"></i>
        </p>

        <h1 class="qrcode-title bold-2">
          {{'Buscar por Responsável' | translate}}
        </h1>

        <h3 class="qrcode-subtitle">
          {{'Ao buscar por responsável, todos os dependentes inscritos nessa
          reunião serão mostrados' | translate}}
        </h3>
      </div>

      <div class="down">
        <ion-button full type="button" class="btn-default" (click)="leitorResponsavel();">{{!responsavelFiltrado ?
          ('Ler Código ' | translate) : ('Ler Outro
          Código ' | translate)}}</ion-button>
      </div>
    </ion-grid>
  </div>
</ion-content>